import React, {useContext} from 'react';
import styled, {ThemeContext} from 'styled-components';
import {
    Menu,
    MenuItem,
    Position,
    Button,
    MenuDivider,
    Classes,
    Tag,
    Popover
} from '@blueprintjs/core';
import { useNavigate } from 'react-router';

import defaultLogo from 'url:../../../../styles/logos/mobile-dashboard-logo.png';
import {AVL_ENVIRONMENT} from "/src/config/vars";

import OrganisationSwitcher from '../organisation-switcher';

const Wrapper = styled.section`
    width: 100%;
    background: #19212F;
    color: rgba(255, 255, 255, 0.8);
    flex: 1;
    order: -1;
    padding: 1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const LogoImg = styled.img`
    max-width: 180px;
    max-height: 30px;
`;
const BoldMenuItem = styled(MenuItem)`
    font-weight: 600;

    & div {
        color: rgb(24, 32, 38);
    }
`;

const MobileSidebar = ({
                           user = {},
                           availableOrganisations = [],
                           logout,
                           menuItems,
                           location
                       }) => {
    const theme = useContext(ThemeContext);
    const navigate = useNavigate();
    const logo =
        theme && theme.logo && theme.logo.mobile
            ? `../assets/logos/${theme.logo.mobile}`
            : defaultLogo;
    const activeItem = menuItems.find(
        (item) =>
            (typeof window === 'object' && item.path) === window.location.pathname
    );

    const productMenu = (
        <Menu>
            <BoldMenuItem icon="user" disabled={true} text={user.email}/>
            {availableOrganisations.length > 1 &&
                <OrganisationSwitcher user={user} availableOrganisations={availableOrganisations} isMobile={true}/>}
            <MenuDivider/>
            {menuItems.map((item, index) => (
                <MenuItem
                    icon={item.icon}
                    key={item.label || index}
                    text={item.label}
                    location={location}
                    onClick={(e) => {
                        if (item.path.includes('https://')) {
                            window.location = item.path;
                        } else {
                            navigate(item.path);
                        }
                    }}
                    disabled={(typeof window === 'object' && item.path) === window.location.pathname}
                />
            ))}
            <MenuItem icon="log-out" text="Logout" onClick={() => navigate(logout)}/>
        </Menu>
    );

    return (
        <Wrapper>
            <LogoImg src={logo} alt="Aura Vision Labs logo"/>
            {AVL_ENVIRONMENT !== "prod" &&
                <Tag
                    large
                    intent={AVL_ENVIRONMENT === "uat" ? "warning" : "danger"}
                    style={{textAlign: "center"}}>
                    {AVL_ENVIRONMENT === "uat" ? "UAT" : "RISK UNKNOWN ENVIRONMENT"}
                </Tag>
            }
            <div>{activeItem && activeItem.label}</div>
            <Popover content={productMenu} position={Position.BOTTOM_LEFT}>
                <Button icon="menu" className={Classes.MINIMAL}/>
            </Popover>
        </Wrapper>
    );
};

export default MobileSidebar;
